import React, { FC } from "react";
import { motion } from "framer-motion";
import Step from "./components/Step";

type StepType = {
  title: string;
  description: string;
};

type Props = {
  onStepChange?(newStep: number): void;
  steps: StepType[];
};

const ScrollStepper: FC<Props> = ({ steps, onStepChange = () => {} }) => {
  return (
    <motion.div
      transition={{ staggerChildren: 0.4, type: "spring", duration: 0.5 }}
    >
      {steps.map((step, index) => (
        <Step
          index={index}
          onStepChange={onStepChange}
          stepNumber={index + 1}
          isLastStep={steps.length - 1 === index}
          {...step}
        />
      ))}
    </motion.div>
  );
};

ScrollStepper.defaultProps = { onStepChange: () => {} };

export default ScrollStepper;
